import React from 'react';
import {
  CalendarAdd16Regular,
  Checkmark16Regular,
  Play16Regular,
} from '@fluentui/react-icons';

import { formatActionDateTime } from '../../utils/actionPresentation';

interface ActionLifecycleRowProps {
  createdAt?: string;
  startedAt?: string;
  completedAt?: string;
  className?: string;
}

const ActionLifecycleRow: React.FC<ActionLifecycleRowProps> = ({ createdAt, startedAt, completedAt, className = '' }) => (
  <div className={`action-lifecycle ${className}`.trim()} aria-label="Action lifecycle">
    <div>
      <span><CalendarAdd16Regular aria-hidden="true" className="action-lifecycle__icon" /> Initiated</span>
      <strong>{formatActionDateTime(createdAt, 'Not reported')}</strong>
    </div>
    <div>
      <span><Play16Regular aria-hidden="true" className="action-lifecycle__icon" /> Execution started</span>
      <strong>{formatActionDateTime(startedAt)}</strong>
    </div>
    <div>
      <span><Checkmark16Regular aria-hidden="true" className="action-lifecycle__icon" /> Completed</span>
      <strong>{formatActionDateTime(completedAt, 'Not completed')}</strong>
    </div>
  </div>
);

export default ActionLifecycleRow;
